/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RuleConditionType {
    FORM_ELEMENT_BASED = 'FormElementBased',
    FORM_STATUS_BASED = 'FormStatusBased',
    WORKFLOW_STATUS_BASED = 'WorkflowStatusBased',
    LOGIN_ACCOUNT_BASED = 'LoginAccountBased',
    TIME_FRAME_BASED = 'TimeFrameBased',
}
